import { UploadFile } from 'antd/lib/upload/interface'
import appAPI from '../api/api'
import { FileDeliveryProgress } from '../api/forum-upload'

export const transferForumFile = async (
  comment: number,
  clientId: string,
  file: UploadFile,
  current: () => boolean,
  progress: (value: FileDeliveryProgress) => void,
) => {
  const blob = file.originFileObj!
  let state = (await appAPI.forumComments.beginUpload({ comment, clientId, filename: file.name, size: blob.size })).data
  while (current() && state.status === 'uploading' && state.uploadedBytes < state.size) {
    const offset = state.uploadedBytes
    const total = state.size
    const chunk = blob.slice(offset, offset + Math.min(state.chunkSize, 1024 * 1024))
    progress({ loaded: offset, total: state.size, phase: 'uploading' })
    try {
      state = (
        await appAPI.forumComments.putUploadChunk(state.id, offset, chunk, (loaded) => {
          if (current()) progress({ loaded: Math.min(offset + loaded, total), total, phase: 'uploading' })
        })
      ).data
    } catch (error: any) {
      if (error.response?.status !== 409) throw error
      state = (await appAPI.forumComments.getUpload(state.id)).data
    }
  }
  if (!current()) return
  if (state.status !== 'complete') {
    state = (await appAPI.forumComments.finishUpload(state.id)).data
  }
  while (current() && state.status === 'queued') {
    progress({ loaded: state.size, total: state.size, phase: 'processing' })
    await new Promise((resolve) => setTimeout(resolve, 1000))
    if (current()) state = (await appAPI.forumComments.getUpload(state.id)).data
  }
  if (!current()) return
  if (state.status !== 'complete')
    throw Object.assign(new Error(state.error || 'Не удалось обработать файл.'), { permanent: true })
  progress({ loaded: state.size, total: state.size, phase: 'done' })
}
